import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Cdr } from "../_types/cdr";
import { Recording } from "../_types/recording";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})

export class RecordingService extends Service<Recording> {
  public override type = 'recording';
  public override url = 'Voip/Recordings'; 
    
  public getDownloadUrl(recording: Recording): string {
    return `${this.getAPIUrl()}/${recording.id}/download`;
  }

  public getDownloadUrlByUniqueId(uniqueId:string): string {
    return `${this.getAPIUrl()}/byuniqueid/${uniqueId}/download`;
  }

  public transcribe(recording: Recording): Observable<Recording> {
    const url = `${this.getAPIUrl()}/transcribe/${recording.id}`;
    return this.http.get<Recording>(url);
  }

}
